module.exports = __webpack_public_path__ + "img/yellow_hover.b15edfd8.png";